import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import styles from './AdminLayout.module.css';

const getLinkClass = ({ isActive }) =>
  isActive ? `${styles.link} ${styles.active}` : styles.link;

export default function AdminLayout() {
  return (
    <div className={styles.container}>
      <h1>Admin Panel</h1>
      <nav className={styles.nav}>
        <NavLink to="/admin" className={getLinkClass} end>
          Dashboard
        </NavLink>
        <NavLink to="/admin/blogs" className={getLinkClass}>
          Manage Blogs
        </NavLink>
        <NavLink to="/admin/events" className={getLinkClass}>
          Rocket City Events
        </NavLink>
        <NavLink to="/admin/data-sync" className={getLinkClass}>
          Data Sync
        </NavLink>
        <NavLink to="/admin/drafts" className={getLinkClass}>
          Manage Drafts
        </NavLink>
        <NavLink to="/admin/stem" className={getLinkClass}>
          STEM Submissions
        </NavLink>
        <NavLink to="/admin/affiliate-links" className={getLinkClass}>
          Affiliate Links
        </NavLink>
        <NavLink to="/admin/nasa-keys" className={getLinkClass}>
          NASA API Keys
        </NavLink>
        <NavLink to="/admin/newsletters" className={getLinkClass}>
          Newsletters
        </NavLink>
        <NavLink to="/admin/newsletter-composer" className={getLinkClass}>
          Newsletter Composer
        </NavLink>
        <NavLink to="/admin/newsletter-analytics" className={getLinkClass}>
          Newsletter Analytics
        </NavLink>
      </nav>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
